import { Grid } from '@mui/material';
import { AppLayout } from 'layout';
import { UserPersonal } from 'modules/Users/components';
import StandardUser from 'modules/Users/components/UserStandardData/StandardUser';

type Props = {};

const PersonalUserStandardContanier = (props: Props) => {
  return (
    <AppLayout>
      <Grid bgcolor={'#FFFFFF'}>
        <StandardUser />
      </Grid>
    </AppLayout>
  );
};

export default PersonalUserStandardContanier;
